"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Course = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const Course = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M40.91,45.84h7.96c1.63,0,2.95-1.32,2.95-2.95V5.45c0-1.63-1.32-2.95-2.95-2.95H21.06\r c-1.63,0-2.95,1.32-2.95,2.95v18.64"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M16.28,53.04l-2.25,6c-0.62,1.65,1.56-0.1,3.21,0.52s2.15,3.37,2.77,1.72l2.13-5.67"
              })
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M33.25,53.24l2.44,6.49c0.62,1.65-1.56-0.1-3.21,0.52c-1.65,0.62-2.15,3.37-2.77,1.72l-2.63-7"
              })
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
          cx: "25.19",
          cy: "38.89",
          r: "12.01"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
          x1: "45.35",
          y1: "12.04",
          x2: "24.58",
          y2: "12.04"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
          x1: "45.35",
          y1: "19.73",
          x2: "24.58",
          y2: "19.73"
        })]
      })]
    })
  });
};
exports.Course = Course;